/**
 * Created by AI assistant on 13.02.26.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { markdownDocVisibility } from './FlowDefMarkdownDocType';

export default declareLinkedEntity({
    entity: "libraryDefMarkdownDocs",
    graphQL: "LibraryDefMarkdownDoc",
    name: "Library Definition Markdown Documentation",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "libraryDefMarkdownDocs",
    defaultTitle: (data) => {
        return data['title'] || data['key'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['libraryDef'],
    fields: (types) => { return {
        id: {
            name: "Library Definition Markdown Documentation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        libraryDef: {
            name: "Library Definition",
            to: () => types['libraryDefs'],
            type: "relation",
            defaultValue: (libraryDef) => {
                return libraryDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        libraryDefVersion: {
            name: "Library Definition Version",
            to: () => types['libraryDefVersions'],
            type: "relation",
            defaultValue: (libraryDef) => {
                return libraryDef['libraryDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            trim: true,
        },
        title: {
            name: "Title",
            type: "string",
            translatable: false,
            defaultValue: "",
        },
        content: {
            name: "Markdown Content",
            type: "text",
            translatable: false,
            defaultValue: "",
        },
        order: {
            name: "Order",
            type: "int",
            defaultValue: 0,
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            defaultValue: "internal",
            values: markdownDocVisibility,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: () => { return {
    }; }
});
